import { Component, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { faTrain } from '@fortawesome/pro-solid-svg-icons';
import { RtvGpsLocation } from '@bds/railtrac-models';
import { firstValueFrom } from 'rxjs';
import { RailtracTripService } from '@bds/railtrac';
import { Router } from '@angular/router';

@Component({
    selector: 'rt-gps-location-details',
    templateUrl: './gps-location-details.component.html',
    styleUrls: ['./gps-location-details.component.scss'],
})
export class GpsLocationDetailsComponent {
    @Input() gpsList: RtvGpsLocation[] = [];
    @Input() count = 0;

    headerSize: string = 'h3';
    iconTrain = faTrain;

    constructor(
        private tripService: RailtracTripService,
        private snackbar: MatSnackBar,
        private router: Router,
    ) {}

    /**
     * Open the Current Trip page in a new tab.
     * @returns void
     */
    async currentTrip(): Promise<void> {
        const selectedGpsLocation = this.gpsList?.[0];
        try {
            if (!selectedGpsLocation?.carInit || !selectedGpsLocation?.carNo) {
                this.snackbar.open('Missing car information', 'Error', { duration: 3000 });
                return;
            }

            // Get the current trip for the specific car
            const currentTrip = await firstValueFrom(
                this.tripService.findCurrentTrip(
                    selectedGpsLocation.carInit,
                    selectedGpsLocation.carNo,
                ),
            );

            if (!currentTrip) {
                this.snackbar.open('No current trip found for this car', 'Info', {
                    duration: 3000,
                });
                return;
            }

            this.snackbar.open(
                `Current trip found: ${currentTrip.carInit} ${currentTrip.carNo} - ${new Date(
                    currentTrip.shipDatetime,
                ).toLocaleDateString()}`,
                'Ok',
                { duration: 3000 },
            );

            const url = this.router.serializeUrl(
                this.router.createUrlTree(['/trip', currentTrip.ormId], {
                    queryParams: { fromInterfaceValidation: 'true' },
                }),
            );
            window.open(url, '_blank');
        } catch (error) {
            this.snackbar.open('Error fetching current trip', 'Error', { duration: 3000 });
        }
    }
}
